module.exports = __webpack_public_path__ + "img/special-for-you.ffb3ea8f.svg";